<template>
    <sidebar-menu
        :menu="routes"
        @toggle-collapse="onToggleCollapse"
        :collapsed="!expanded"
        width="270px"
        width-collapsed="50px"
        theme="default-theme"
        :showOneChild="true"
        id="sidebar"
    />
</template>

<script>

    import Routes from '~/routes';
    import constructSidebarEntriesFromRoutes from '~/core/mixins/RoutingMixin';

    // Sidebar navigation component
    export default {
        name: "Sidebar",
        data() {
            return {
                routes: [],
                expanded: this.$store.getters['sidebar/expanded']
            }
        },
        methods: {
            // @vuese
            // Load routes for sidebar and render
            render() {
                let routes = Routes;

                this.routes = constructSidebarEntriesFromRoutes(routes);
            },

            onToggleCollapse(collapsed) {
                this.$store.commit('sidebar/toggle');
                return false;
            },

            setBodyClass(expanded) {
                if (expanded) {
                    document.getElementById('container').classList.add('mainnav-lg');
                    document.getElementById('container').classList.remove('mainnav-sm');
                } else {
                    document.getElementById('container').classList.remove('mainnav-lg');
                    document.getElementById('container').classList.add('mainnav-sm');
                }
            }
        },
        mounted() {
            this.render();

            this.$store.watch(function(state) {
                return state.sidebar.expanded;
            }, (input) => {
                this.expanded = input;
                this.setBodyClass(input);
            }, {
                deep: true
            });

            this.setBodyClass(this.expanded);
        }
    }
</script>

<style>
.v-sidebar-menu {
    top: 40px !important;
    background-color: rgb(43, 58, 72);
    z-index: 2;
}

.v-sidebar-menu .vsm--link {
    font-size: 13px;
    padding: 2px 10px;
}

.v-sidebar-menu .vsm--link.vsm--link_level-1 {
    padding: 5px 7px;
}

.v-sidebar-menu .vsm-item.first-item>.vsm-link>.vsm-icon {
    color: #fff;
    background-color: inherit;
}

.vsm-title {
    font-size: 13px;
    font-family: 'Open Sans', serif;
    font-weight: 400;
}

.vsm--list {
    padding-top: 10px;
}

.v-sidebar-menu .vsm-dropdown>.vsm-list {
    background-color: rgb(37, 50, 62);
}

.v-sidebar-menu .vsm-item.first-item.active-item>.vsm-link>.vsm-icon, .v-sidebar-menu .vsm-item.first-item.parent-active-item>.vsm-link>.vsm-icon {
    color: #fff;
    background-color: inherit;
}

.vsm-link:hover>.vsm-icon {
    background-color: rgba(36,44,53) !important;
}

.v-sidebar-menu .collapse-btn {
    height: 0px;
}

.v-sidebar-menu .vsm-item.active-item {
    color: white;
}

.v-sidebar-menu .vsm-item.parent-active-item {
    color: white;
}

.v-sidebar-menu .vsm-link {
    color: inherit;
}

.v-sidebar-menu .vsm-dropdown > .vsm-list .vsm-link {
    color: inherit;
    margin-left: 50px;
}

#sidebar > .collapse-btn {
    display: none;
}

.v-sidebar-menu .vsm--toggle-btn {
    height: 35px;
}
</style>
